import { useEffect, useState } from "react";
import { ImageOff } from "lucide-react";
import { qgApi } from "@/lib/qgApi";

const cache = new Map();

export function AuthImage({ imageId, alt = "", className = "", testId }) {
  const [src, setSrc] = useState(cache.get(imageId) || null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let alive = true;
    setFailed(false);
    if (!imageId) return undefined;
    if (cache.has(imageId)) { setSrc(cache.get(imageId)); return undefined; }
    qgApi.imageBlob(imageId)
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        cache.set(imageId, url);
        if (alive) setSrc(url);
      })
      .catch(() => alive && setFailed(true));
    return () => { alive = false; };
  }, [imageId]);

  if (failed) {
    return <div className={`flex items-center justify-center bg-slate-100 text-slate-400 ${className}`} data-testid={testId}><ImageOff className="h-5 w-5" /></div>;
  }
  if (!src) return <div className={`animate-pulse bg-slate-100 ${className}`} data-testid={testId} />;
  return <img src={src} alt={alt} className={`object-contain bg-white ${className}`} data-testid={testId} />;
}
